module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/students-e07795a1c4a1c29d259cd6a716d8b5cd.png";